import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injector } from '@angular/core';
import { AccessDeniedModalComponent } from '../_shared/components/access-denied-modal/access-denied-modal.component';
import * as i0 from "@angular/core";
var AccessDeniedModalService = /** @class */ (function () {
    function AccessDeniedModalService(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.isModalOpen = false;
        this.componentRef = null;
        this.closeSubscription = null;
    }
    AccessDeniedModalService.prototype.showAccessDeniedModal = function () {
        var _this = this;
        if (this.isModalOpen) {
            return;
        }
        this.isModalOpen = true;
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(AccessDeniedModalComponent);
        this.componentRef = componentFactory.create(this.injector);
        this.closeSubscription = this.componentRef.instance.closed.subscribe(function () { return _this.closeAccessDeniedModal(); });
        this.appRef.attachView(this.componentRef.hostView);
        var element = this.componentRef.hostView.rootNodes[0];
        document.body.appendChild(element);
        this.componentRef.changeDetectorRef.detectChanges();
    };
    AccessDeniedModalService.prototype.closeAccessDeniedModal = function () {
        if (!this.isModalOpen) {
            return;
        }
        if (this.componentRef) {
            if (this.closeSubscription) {
                this.closeSubscription.unsubscribe();
                this.closeSubscription = null;
            }
            this.appRef.detachView(this.componentRef.hostView);
            this.componentRef.destroy();
            this.componentRef = null;
        }
        this.isModalOpen = false;
    };
    AccessDeniedModalService.ngInjectableDef = i0.defineInjectable({ factory: function AccessDeniedModalService_Factory() { return new AccessDeniedModalService(i0.inject(i0.ComponentFactoryResolver), i0.inject(i0.ApplicationRef), i0.inject(i0.INJECTOR)); }, token: AccessDeniedModalService, providedIn: "root" });
    return AccessDeniedModalService;
}());
export { AccessDeniedModalService };
